const RECAPTCHA_PROD_KEY = '6Lf11hkUAAAAAChIm_uOYzZK4MRNlblRpcC70c6c'
const RECAPTCHA_DEV_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'

const prodHostnames = [
  'claimuploadcenter.travelers.com',
  'travelers.com',
  'www.travelers.com',
  'claim.travelers.com'
]

const qaHostnames = [
  'travelers-qa.travelers.com',
  'claimuploadcenter-travelers-qa.travelers.com',
  'claim-mo.travelers.com'
]

const getReCaptchaKey = (hostname: string) => {
    if (prodHostnames.includes(hostname) || qaHostnames.includes(hostname)) {
      return RECAPTCHA_PROD_KEY
    }

    return RECAPTCHA_DEV_KEY
}

const getTealiumUrl = (hostname: string) => {
  let tealiumEnv
  if (prodHostnames.includes(hostname)) {
    tealiumEnv = 'prod'
  } else {
    tealiumEnv = 'dev'
  }

  return `https://tags.tiqcdn.com/utag/travelers/claim-file-uploader/${tealiumEnv}/utag.js`
}

export { getReCaptchaKey, getTealiumUrl }
